import { useLocation } from "react-router";

export const useCheckIfFormIsActive = (route) => {
  const { pathname } = useLocation();
  return route === pathname;
};
